"use client";

// eslint-disable-next-line no-restricted-imports -- it is the component replacing default next/link
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import type { ComponentPropsWithRef } from "react";

import { getClientSideURL } from "../helpers/get-url";

export interface MigrationLinkProps extends ComponentPropsWithRef<typeof NextLink> {
  href: string;
}

const migratedPaths = new Set(["/", "/membership", "/akcjazdrowia", "/rekrutacja", "/o-nas"]);

export function MigrationLink({ children, href, ...props }: MigrationLinkProps) {
  const pathname = usePathname();

  if (!href) {
    throw new Error("href is required");
  }

  const isExternal = !href.startsWith("/") && !href.startsWith("#");
  const isCrossMigration = migratedPaths.has(pathname) !== migratedPaths.has(href);

  return isExternal || isCrossMigration ? (
    <a
      href={href}
      {...props}
      {...(isExternal && !isTrustedUrl(href) && { rel: "noopener noreferrer", target: "_blank" })}
    >
      {children}
    </a>
  ) : (
    <NextLink href={href} {...props}>
      {children}
    </NextLink>
  );
}

function isTrustedUrl(url: string) {
  const trustedHostname = new URL(getClientSideURL()).hostname;
  try {
    const urlHostname = new URL(url).hostname;
    return urlHostname.includes(trustedHostname);
  } catch {
    return false;
  }
}
